import { defineTokens } from '@chakra-ui/react'

export const colors = defineTokens.colors({
  light: {
    50: { value: '#FFFFFF' },
    100: { value: '#FEFEFE' },
    200: { value: '#FAFAFA' },
    300: { value: '#F5F5F5' },
    400: { value: '#EEEEEE' },
    500: { value: '#E0E0E0' },
    600: { value: '#D6D6D6' },
    700: { value: '#CCCCCC' },
    800: { value: '#C2C2C2' },
    900: { value: '#B8B8B8' },
  },
  gray: {
    50: { value: '#F7FAFC' },
    100: { value: '#fbfdfe' },
    200: { value: '#E2E8F0' },
    300: { value: '#CBD5E0' },
    400: { value: '#A0AEC0' },
    500: { value: '#718096' },
    600: { value: '#4A5568' },
    700: { value: '#2D3748' },
    800: { value: '#1A202C' },
    900: { value: '#171923' },
  },
  orange: {
    50: { value: '#FFFAF0' },
    100: { value: '#FEEBC8' },
    200: { value: '#FBD38D' },
    300: { value: '#F6AD55' },
    400: { value: '#ED8936' },
    500: { value: '#DD6B20' },
    600: { value: '#C05621' },
    700: { value: '#9C4221' },
    800: { value: '#7B341E' },
    900: { value: '#652B19' },
  },
})
